import { Zap, ShoppingCart, Phone } from 'lucide-react';

const GamingPackagesSection = () => {
  const gamingPackages = [
    {
      name: 'Gaming Starter',
      speed: '50 Mbps',
      price: 'Rp 299.000',
      features: [
        'Ping < 20ms ke server lokal',
        'Upload 25 Mbps',
        'IP Publik Static',
        'Gaming Router WiFi 6',
        'Steam Wallet Rp 100.000'
      ],
      popular: false,
      color: 'from-blue-500 to-blue-800'
    },
    {
      name: 'Gaming Pro',
      speed: '100 Mbps',
      price: 'Rp 499.000',
      features: [
        'Ping < 10ms ke server lokal',
        'Upload 50 Mbps',
        'IP Publik Static',
        'Gaming Router WiFi 6E',
        'Steam Wallet Rp 200.000',
        'Priority Bandwidth'
      ],
      popular: true,
      color: 'from-blue-700 to-blue-600'
    },
    {
      name: 'Gaming Ultra',
      speed: '300 Mbps',
      price: 'Rp 899.000',
      features: [
        'Ping < 5ms ke server lokal',
        'Upload 100 Mbps',
        'Dedicated IP Static',
        'Gaming Router WiFi 7',
        'Steam Wallet Rp 500.000',
        'Priority Bandwidth',
        'Gaming VPN Access'
      ],
      popular: false,
      color: 'from-blue-700 to-blue-800'
    }
  ];

  // Fungsi untuk mengarahkan ke WhatsApp dengan pesan custom
  const handleOrder = (packageName, speed, price) => {
    const phoneNumber = '6287778882022';
    const message = `Halo, saya ingin berlangganan paket ${packageName} (${speed}) seharga ${price}. Bisa dibantu untuk pemasangannya?`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    
    window.open(whatsappURL, '_blank');
  };

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl sm:text-5xl font-black text-center mb-16">
          <span className="bg-gradient-to-r from-cyan-400 to-blue-600 bg-clip-text text-transparent">
            Gaming Packages
          </span>
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {gamingPackages.map((pkg, index) => (
            <div key={index} className={`relative bg-gray-800/60 backdrop-blur-md rounded-2xl p-8 border-2 transition-all duration-300 transform hover:scale-105 ${
              pkg.popular ? 'border-blue-700 shadow-2xl shadow-blue-700/25' : 'border-gray-700 hover:border-cyan-500/50'
            }`}>
              {pkg.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-gradient-to-r from-blue-700 to-blue-700 px-4 py-2 rounded-full text-sm font-bold flex items-center gap-2">
                    <Zap className="w-4 h-4" />
                    MOST POPULAR
                  </span>
                </div>
              )}

              <div className={`w-16 h-16 bg-gradient-to-r ${pkg.color} rounded-2xl flex items-center justify-center mb-6 mx-auto`}>
                <Zap className="w-8 h-8 text-white" />
              </div>

              <h3 className="text-2xl font-bold text-center mb-2">{pkg.name}</h3>
              <div className="text-center mb-6">
                <span className="text-4xl font-black bg-gradient-to-r from-cyan-400 to-blue-600 bg-clip-text text-transparent">
                  {pkg.speed}
                </span>
                <div className="text-2xl font-bold text-white mt-2">{pkg.price}</div>
                <div className="text-gray-400">/bulan</div>
              </div>

              <ul className="space-y-3 mb-8">
                {pkg.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-gray-300">
                    <div className="w-2 h-2 bg-cyan-400 rounded-full mr-3"></div>
                    {feature}
                  </li>
                ))}
              </ul>

              <button 
                onClick={() => handleOrder(pkg.name, pkg.speed, pkg.price)}
                className={`w-full py-3 rounded-full font-bold transition-all duration-300 flex items-center justify-center gap-2 ${
                  pkg.popular 
                    ? 'bg-gradient-to-r from-blue-700 to-blue-700 hover:from-blue-600 hover:to-blue-600 text-white' 
                    : 'border-2 border-cyan-400 hover:bg-cyan-400 hover:text-gray-900 text-cyan-400'
                }`}
              >
                {pkg.popular ? (
                  <>
                    <ShoppingCart className="w-5 h-5" />
                    Pesan Sekarang
                  </>
                ) : (
                  <>
                    <Phone className="w-5 h-5" />
                    Hubungi Sales
                  </>
                )}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GamingPackagesSection;